/* eslint-disable */
import React, {useEffect} from "react";
import Button from "@material-ui/core/Button";
import styles from "./SelectSkill.module.css";
import {FormControl, InputLabel, FilledInput, InputAdornment, createStyles, makeStyles, Theme, Checkbox, FormControlLabel, Chip, Divider} from "@material-ui/core";
import Search from "@material-ui/icons/Search";
import {GetSkillList} from "../../user/UserActions";
import {useDispatch, useSelector} from "react-redux";
import {AppState} from "../../root/RootReducer";
import CheckboxIcon from "../../common/components/images/CheckboxIcon";
import CheckboxCheckedIcon from "../../common/components/images/CheckboxCheckedIcon";

const useStyles = makeStyles((_theme: Theme) =>
    createStyles({
        searchTitle: {
            fontSize: "16px",
       },
        searchInput: {
            height: "55px",
            fontSize: "20px",
            borderRadius: "3px",
       },
        searchButton: {
            fontSize: "1rem",
            borderRadius: "5px",
            marginRight: "15px",
            backgroundColor: "var(--red)",
            "&:hover": {
                backgroundColor: "rgb(193, 0, 25)",
           }
       },
        addButton: {
            fontSize: "1rem",
            borderRadius: "5px",
            backgroundColor: "var(--red)",
            "&:hover": {
                backgroundColor: "rgb(193, 0, 25)",
           }
       }
   }),
);

interface SelectSkillProps {
    /* モーダル表示切り替え */
    in: boolean;
    // モーダル閉じる
    onClose?: () => void;
    userName: string;
    userSkills: string[];
    SetUserSkills: (userSkills: string[]) => void;
    SetIsSaved?: (flg: boolean) => void;
}

const SelectSkill = React.forwardRef<HTMLDivElement, SelectSkillProps>(function SelectSkill(props, ref) {
    const {onClose, userName, SetUserSkills, userSkills, SetIsSaved} = props;
    const classes = useStyles();
    const dispatch = useDispatch();
    const [editSkills, ChangeEditSkills] = React.useState<string[]>(props.userSkills);
    const [searchKey, setSearchKey] = React.useState("");
    const {skillList} = useSelector(({user}: AppState) => user);
    const [displaySkillList, ChangeDisplaySkillList] = React.useState(skillList);
    const [searchSkill, ChangeSearchSkill] = React.useState<string[]>([]);
    const [isLimitSkill, ChangeLimitSkill] = React.useState(false);

    const InputSearchSkill = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchKey(event.currentTarget.value.trim());
        const input = event.currentTarget.value.trim().split(/\s+/);
        if (input.length > 0 && input[0] !== "") {
            dispatch(GetSkillList(input));
            ChangeSearchSkill(input);
       } else {
            dispatch(GetSkillList([]));
            ChangeSearchSkill([]);
       }
   };

    const DeleteSkill = (deleteSkillName: string) => () => {
        ChangeEditSkills(editSkills.filter(v => v !== deleteSkillName));
   };

    const CheckSkill = (event: React.ChangeEvent<HTMLInputElement>) => {
        let tempList = editSkills;
        if (!event.currentTarget.checked) {
            tempList = tempList.filter(v => v !== event.currentTarget.name);
       } else {
            tempList = tempList.concat(event.currentTarget.name);
       }
        ChangeEditSkills(tempList);
   };


    useEffect(() => {
        if(editSkills.length > 5){
            ChangeLimitSkill(true);
       }
        else{
            ChangeLimitSkill(false);
       }
   }, [editSkills]);

    useEffect(() => {
        dispatch(GetSkillList([]));
   }, [dispatch]);

    // 検索していないときは新規追加したスキルを合わせて表示する、検索時はフィルター結果のみ表示する
    useEffect(() => {
        console.log("displaySkillList更新");
        if(searchSkill.length === 0){
            const diffSkillList = userSkills.filter(i => skillList.indexOf(i) === -1);
            ChangeDisplaySkillList(prev => [...new Set([...prev, ...diffSkillList])]); 
       }
        else{
            ChangeDisplaySkillList(skillList);
       }
        console.log(displaySkillList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [userSkills, skillList]);

    // ------------------新規スキル追加 ------------------ //
    const [newSkill, SetNewSkill] = React.useState<string>("");
    const InputAddSkill = (event: React.ChangeEvent<HTMLInputElement>) => {
        // MAX15文字制限
        if (event.currentTarget.value.length <= 15 && event.currentTarget.value.length >= 0) {
            SetNewSkill(event.currentTarget.value);
       }
        // SetNewSkill(event.currentTarget.value);
   };

    const AddNewSkill = () => {
        const addKey = searchKey !== newSkill && newSkill !== "" ? newSkill : searchKey;
        if (!editSkills.includes(addKey)) {
            ChangeEditSkills([...editSkills, addKey]);
       }
        SetNewSkill("");
   };

    // 編集完了
    const ConfirmSkill = () => {
        if (onClose) {
            if(!isLimitSkill){
                SetUserSkills(editSkills);
                if (SetIsSaved) {
                    SetIsSaved(false);
               }
                onClose();
                SetNewSkill("");
           }
       }
   };

    const handleCancel = () => {
        if(onClose) onClose();
   };

    return (
        <>
            <div className={styles.root}>
                <div className={styles.conditionArea}>
                    <div style={{display: "block", marginBottom: "15px"}}>
                        <h2>名前: {userName}</h2>
                        <h2>現在の保有Skill( {editSkills.length}/ 5 ):</h2>
                        <div style={{display:"flex"}}>
                            {
                                editSkills &&
                                editSkills.map((skill) => (
                                    <div key={skill} style={{marginRight:"7px"}}>
                                        <Chip label={skill} color="secondary" style={{backgroundColor: "var(--red)"}} size="medium" onDelete={DeleteSkill(skill)} />
                                    </div>
                                ))
                           }
                        </div>
                    </div>
                    <Divider variant="middle"/>
                    <h2>Skillの追加</h2>
                </div>
                <div className={styles.skillArea}>
                    <h2>■登録されているSkillから追加</h2>
                    <FormControl fullWidth variant="filled" color="secondary">
                        <InputLabel htmlFor="searchInput" className={classes.searchTitle}>
                            検索したいスキルを入力
                        </InputLabel>
                        <FilledInput
                            id="searchInput"
                            onChange={InputSearchSkill}
                            startAdornment={
                                <InputAdornment position="start">
                                    <Search color="secondary" style={{color: "var(--red)"}} />
                                </InputAdornment>
                           }
                            autoComplete={"off"}
                            className={classes.searchInput}
                        />
                    </FormControl>
                    <div className={styles.skillScrollArea}>
                        {
                            displaySkillList.map((item, index) => (
                                <FormControlLabel
                                    key={index}
                                    control={
                                        <Checkbox
                                            icon={<div className={styles.checkedIcon}><CheckboxIcon /></div>}
                                            checkedIcon={<div className={styles.checkedIcon}><CheckboxCheckedIcon /></div>}
                                            name={item}
                                            checked={editSkills.includes(item)}
                                            onChange={CheckSkill}
                                        />
                                   }
                                    label={item}
                                    className={styles.skillCheckBox}
                                />
                            ))
                       }
                    </div>
                    <div className={styles.addSkillArea}>
                        <Divider variant="middle"/>
                        <h2>■Skillを新規に作成して追加</h2>
                        <FormControl fullWidth variant="filled" color="secondary">
                            <InputLabel htmlFor="newSkillInput" className={classes.searchTitle}>
                                新規Skill名を入力
                            </InputLabel>
                            <FilledInput
                                id="newSkillInput"
                                value={newSkill}
                                onChange={InputAddSkill}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            className={classes.addButton}
                                            onClick={AddNewSkill}
                                            disabled={newSkill.length === 0}
                                        >
                                            追加
                                        </Button>
                                    </InputAdornment>
                               }
                                defaultValue={searchKey}
                                autoComplete={"off"}
                                className={classes.searchInput}
                            />
                        </FormControl>
                    </div>
                </div>
                <div className={styles.btnArea}>
                    {isLimitSkill && <p style={{color:"var(--red)", fontSize:"15px"}}>※登録できるスキルは5件までです。</p>}
                    <Button
                        variant="contained"
                        color="secondary"
                        className={classes.searchButton}
                        onClick={handleCancel}
                    >
                        キャンセル
                    </Button>
                    <Button
                        variant="contained"
                        color="secondary"
                        className={classes.searchButton}
                        onClick={ConfirmSkill}
                        disabled={isLimitSkill || editSkills === props.userSkills}
                    >
                        編集完了
                    </Button>
                </div>
            </div>
        </>
    );
});

export default SelectSkill;
